import {createTippy} from '../modules/tippy.ts';
import {toggleElem} from '../utils/dom.ts';
import {GET} from '../modules/fetch.ts';
import {registerGlobalEventFunc, registerGlobalInitFunc} from '../modules/observer.ts';

export function initRepoEllipsisButton() {
  registerGlobalEventFunc('click', 'onRepoEllipsisButtonClick', async (el: HTMLInputElement, e: Event) => {
    e.preventDefault();
    const expanded = el.getAttribute('aria-expanded') === 'true';
    toggleElem(el.parentElement!.querySelector('.commit-body')!);
    el.setAttribute('aria-expanded', String(!expanded));
  });
}

export function initCommitStatuses() {
  registerGlobalInitFunc('initCommitStatuses', (el: HTMLElement) => {
    const nextEl = el.nextElementSibling!;
    if (!nextEl.matches('.tippy-target')) throw new Error('Expected next element to be a tippy target');
    const lazyUrl = el.getAttribute('data-lazy-url');
    let loading = false, loaded = false;
    createTippy(el, {
      content: nextEl,
      placement: 'bottom-start',
      interactive: true,
      role: 'dialog',
      theme: 'box-with-header',
      onShow: lazyUrl ? (instance) => {
        // the status list is rendered on the server only when it is needed for the first time
        if (loading || loaded) return;
        loading = true;
        (async () => {
          try {
            const resp = await GET(lazyUrl);
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
            nextEl.innerHTML = await resp.text();
            loaded = true;
          } catch (e) {
            console.error('Failed to load commit statuses', e);
            nextEl.textContent = window.config.i18n.error_occurred;
          } finally {
            loading = false;
            instance.popperInstance?.update();
          }
        })();
      } : undefined,
    });
  });
}

export function initAvatarStackPopup() {
  registerGlobalInitFunc('initAvatarStackPopup', (el: HTMLElement) => {
    const nextEl = el.nextElementSibling!;
    if (!nextEl.matches('.tippy-target')) throw new Error('Expected next element to be a tippy target');
    createTippy(el, {
      content: nextEl,
      placement: 'bottom-start',
      interactive: true,
      role: 'dialog',
      theme: 'menu',
      trigger: 'click',
      hideOnClick: true,
    });
  });
}

export function initCommitFileHistoryFollowRename() {
  registerGlobalInitFunc('initCommitHistoryFollowRename', (el: HTMLInputElement) => {
    el.addEventListener('change', () => {
      const url = new URL(window.location.toString());
      url.searchParams.set('follow-rename', String(el.checked));
      window.location.assign(url.href);
    });
  });
}
